import { API_URL, getAuthHeaders } from '@config/api';
import { ApiResponse, ApiErrorCode, ApiError } from '@/types/api';
import { ErrorService } from './errorService';
import { authManager } from './auth/authManager';

const handleUnauthorized = () => {
  console.log('🔒 - api.ts - Iniciando logout por não autorizado');
  authManager.logout();
  console.log('✅ - api.ts - Logout completado');
};

const processResponse = async (response: Response) => {
  const contentType = response.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    return await response.json();
  }
  return await response.text();
};

export const api = {
  API_URL,
  headers: getAuthHeaders,

  async request<T>(
    url: string,
    options: RequestInit = {}
  ): Promise<ApiResponse<T> | ApiError> {
    console.log('📡 - api.ts - Iniciando requisição para:', url,getAuthHeaders());
    const response = await fetch(url, {
      ...options,
      headers: getAuthHeaders(),
    });
    if (!response.ok) {
      console.log('❌ - api.ts - Erro na resposta:', response.status);
      const error = await ErrorService.handleApiError(response);
      if (ErrorService.getErrorCodeFromStatus(error.statusCode) == ApiErrorCode.UNAUTHORIZED)
        handleUnauthorized();
      throw error;
    }
    const data = await processResponse(response);
    console.log('✅ - api.ts - Dados recebidos com sucesso');
    return { data };
  },

  async uploadRequest<T>(
    url: string,
    formData: FormData,
    onProgress?: (progress: number) => void
  ): Promise<ApiResponse<T> | ApiError> {
    console.log('📡 - api.ts - Iniciando upload para:', url);
    
    const xhr = new XMLHttpRequest();
    
    return new Promise((resolve, reject) => {
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const progress = (event.loaded * 100) / event.total;
          onProgress?.(Math.round(progress));
        }
      };

      xhr.onload = async () => {
        try {
          if (xhr.status >= 200 && xhr.status < 300) {
            const contentType = xhr.getResponseHeader('content-type');
            let response;
            
            if (contentType && contentType.includes('application/json')) {
              response = JSON.parse(xhr.responseText);
            } else {
              response = xhr.responseText;
            }
            
            resolve({ data: response });
          } else {
            const error = await ErrorService.handleApiError(
              new Response(xhr.responseText, { 
                status: xhr.status,
                statusText: xhr.statusText 
              })
            );
            
            if (ErrorService.getErrorCodeFromStatus(error.statusCode) === ApiErrorCode.UNAUTHORIZED) {
              handleUnauthorized();
            }
            
            reject(error);
          }
        } catch (error) {
          reject(new Error('Erro ao processar resposta do servidor'));
        }
      };

      xhr.onerror = () => {
        reject(new Error('Falha na conexão com o servidor'));
      };

      xhr.ontimeout = () => {
        reject(new Error('Tempo limite de conexão excedido'));
      };

      xhr.open('POST', `${API_URL}${url}`, true);
      
      const headers = this.headers();
      Object.keys(headers).forEach(key => {
        if (key !== 'Content-Type') {
          xhr.setRequestHeader(key, headers[key]);
        }
      });

      // Permite uploads de arquivos grandes aumentando o timeout de 30s para 10 minutos (600000ms)
      xhr.timeout = 600000;
      xhr.send(formData);
    });
  }
};
